module.exports = __webpack_public_path__ + "static/media/logo.04640004.svg";